import Listener from "~/ts/library/listen/Listener";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";
import NewWebRtcCall from "~/ts/library/webRtc/comet/NewWebRtcCall";
import NewWebRtcCallStartedByYou from "~/ts/library/webRtc/comet/NewWebRtcCallStartedByYou";
import WebRtcCallRequestOffer from "~/ts/library/webRtc/comet/WebRtcCallRequestOffer";
import WebRtcCallRequestAnswer from "~/ts/library/webRtc/comet/WebRtcCallRequestAnswer";
import WebRtcCallReceiveAnswer from "~/ts/library/webRtc/comet/WebRtcCallReceiveAnswer";
import WebRtcCallNewIceCandidates from "~/ts/library/webRtc/comet/WebRtcCallNewIceCandidates";
import WebRtcCallFinished from "~/ts/library/webRtc/comet/WebRtcCallFinished";
import WebRtcCallDataUpdate from "~/ts/library/webRtc/comet/WebRtcCallDataUpdate";
import WebRtcCallPing from "~/ts/library/webRtc/comet/WebRtcCallPing";

export default function initializeWebRtc(
    realizationClass: Function & { prototype: AbstractWebRtcCall },
    cometListener: Listener
) {
    AbstractWebRtcCall.realizationClass = realizationClass;
    cometListener
        .listenAction(new NewWebRtcCall())
        .listenAction(new NewWebRtcCallStartedByYou())
        .listenAction(new WebRtcCallRequestOffer())
        .listenAction(new WebRtcCallRequestAnswer())
        .listenAction(new WebRtcCallReceiveAnswer())
        .listenAction(new WebRtcCallNewIceCandidates())
        .listenAction(new WebRtcCallFinished())
        .listenAction(new WebRtcCallDataUpdate())
        .listenAction(new WebRtcCallPing());
}